// extracted by mini-css-extract-plugin
module.exports = {"section":"sub-page-client-swiper-module--section--4WVz8"};